import { updateDataInArray } from '../../utils/function.utils'
import ReportTypes from './report.types'

const INITIAL_STATE = {
	data: null,
	total: 0,
	page: 1,
	selectedReport: null,
}

const FeedbackReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case ReportTypes.GET_REPORTS:
			return {
				...state,
				...payload,
			}
		case ReportTypes.UPDATE_REPORTS:
			return {
				...state,
				data: updateDataInArray(state.data, payload),
			}
		case ReportTypes.SELECT_REPORTS:
			return {
				...state,
				selectedReport: payload,
			}
		default:
			return state
	}
}

export default FeedbackReducer
